import React from 'react'
import { PrismicRichText } from '@prismicio/react'

const CheckList = ({ slice }) => {
  return (
    <section className='component-checklist relative mx-auto max-w-screen-xl py-6 px-4'>
      {slice.primary.title.richText && (
        <div className='prose prose-blue mb-3 min-w-full'>
          <PrismicRichText field={slice.primary.title.richText} />
        </div>
      )}
      <ul className={`component-${slice.slice_type} prose prose-xl`}>
        {slice.items.map((item, index) => {
          return (
            <li className='flex flex-row items-start' key={`item-${index}`}>
              <span className='mr-2 mt-2 text-orange-500'>
                <svg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 0 24 24' width='24'>
                  <path d='M0 0h24v24H0z' fill='none' />
                  <path fill='currentColor' d='M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z' />
                </svg>
              </span>
              {item.list_item_text.text}
            </li>
          )
        })}
      </ul>
    </section>
  )
}

export default CheckList
